import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import List, {
  ListItem,
  ListItemText,
  ListItemSecondaryAction
} from "material-ui/List";
import ModalFormDialog from "./ModalFormDialog";
import TextField from "material-ui/TextField";
import Switch from "material-ui/Switch";
import Select from "material-ui/Select";
import { capitalize } from "./helpers/presentation";

const styles = theme => ({
  switchGroup: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  listItem: {
    minHeight: 60
  },
  rightLabel: {
    width: 120
  },
  select: {
    paddingTop: 9
  }
});

const EditCostLimitDialog = props => {
  const {
    costLimit,
    open,
    onSave,
    onChange,
    onCancel,
    accountName,
    classes
  } = props;

  const handleActionChange = event => {
    onChange({
      infoOnly: event.target.value === "infoOnly",
      killInstances: event.target.value === "killInstances"
    });
  };

  const handleRecurringChange = (event, checked) => {
    onChange({ isRecurring: checked });
  };

  const handleDateChange = (event, dateType) => {
    onChange({ [dateType]: event.target.value });
  };

  const handleLimitChange = event => {
    onChange({ limit: event.target.value });
  };

  const renderDialogTitle = () => {
    switch (costLimit.propertyType) {
      case "account":
        return `${accountName} - id:${costLimit.propertyKey}`;
      case "project":
        let splitProjectName = costLimit.propertyKey.split("|");
        return `${splitProjectName[1]} - id:${splitProjectName[0]}`;
      default:
        return costLimit.propertyKey;
    }
  };

  return (
    <ModalFormDialog
      title="Edit Cost Limit"
      open={open}
      onCancel={onCancel}
      onSave={onSave}
    >
      <List>
        <ListItem>
          <ListItemText
            primary={capitalize(costLimit.propertyType)}
            secondary={renderDialogTitle()}
          />
        </ListItem>
        <ListItem>
          <TextField
            id="startDate"
            label="Start Date"
            type="date"
            defaultValue={costLimit.startDate}
            className={classes.textField}
            disabled={new Date(costLimit.startDate) < Date.now()}
            fullWidth={true}
            onChange={e => {
              handleDateChange(e, "startDate");
            }}
          />
          <TextField
            id="endDate"
            label="End Date"
            type="date"
            defaultValue={costLimit.endDate}
            className={classes.textField}
            fullWidth={true}
            onChange={e => {
              handleDateChange(e, "endDate");
            }}
          />
        </ListItem>
        <ListItem>
          <ListItemText primary="Recurring?" />
          <ListItemSecondaryAction>
            <div className={classes.switchGroup}>
              <Switch
                checked={costLimit.isRecurring}
                onChange={handleRecurringChange}
              />
            </div>
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <ListItemText primary="Action" />
          <ListItemSecondaryAction>
            <Select
              native={true}
              onChange={handleActionChange}
              className={classes.select}
            >
              <option value="infoOnly">Send Email</option>
              <option value="holdPendingTasks">Hold Pending Tasks</option>
              <option value="killInstances">Kill Frames</option>
            </Select>
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <TextField
            id="spent"
            label={`Spent ${costLimit.units}`}
            type="number"
            defaultValue={`${costLimit.spent}`}
            className={classes.textField}
            disabled={true}
            fullWidth={true}
          />
          <TextField
            id="limit"
            label={`Limit ${costLimit.units}`}
            type="number"
            defaultValue={`${costLimit.limit}`}
            className={classes.textField}
            fullWidth={true}
            onChange={handleLimitChange}
          />
        </ListItem>
      </List>
    </ModalFormDialog>
  );
};

EditCostLimitDialog.propTypes = {
  costLimit: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export { EditCostLimitDialog };

export default withStyles(styles, { name: "EditCostLimitDialog" })(
  EditCostLimitDialog
);



// WEBPACK FOOTER //
// ./src/EditCostLimitDialog.js